import React, { useState } from "react";
import { Check, Clock, Video, ArrowUpRight } from "lucide-react";

const TIDYCAL_URL = "https://tidycal.com/dbenson/60-minute-meeting";

export default function BookDemo() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div data-testid="book-demo-page">
      {/* HEADER */}
      <section className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 md:py-20">
          <div className="grid lg:grid-cols-12 gap-10 items-start">
            <div className="lg:col-span-5">
              <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#22A34A] mb-4">
                Book a Demo
              </div>
              <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.05]">
                Let&apos;s walk through QC4Health together.
              </h1>
              <p className="mt-6 text-lg text-slate-600 leading-relaxed">
                Pick a time that suits you. We&apos;ll tailor the walkthrough to
                your governance program, show the modules in action and
                answer your specific questions.
              </p>

              <div className="mt-8 space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-xl bg-[#22A34A]/10 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-4 h-4 text-[#22A34A]" />
                  </div>
                  <div>
                    <div className="font-heading font-semibold text-slate-900">
                      60 minutes
                    </div>
                    <div className="text-sm text-slate-600">
                      Enough time to explore modules and Q&A.
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-xl bg-[#22A34A]/10 flex items-center justify-center flex-shrink-0">
                    <Video className="w-4 h-4 text-[#22A34A]" />
                  </div>
                  <div>
                    <div className="font-heading font-semibold text-slate-900">
                      Video call
                    </div>
                    <div className="text-sm text-slate-600">
                      Meeting link is emailed after booking.
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-xl bg-[#22A34A]/10 flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-[#22A34A]" />
                  </div>
                  <div>
                    <div className="font-heading font-semibold text-slate-900">
                      Tailored to you
                    </div>
                    <div className="text-sm text-slate-600">
                      We&apos;ll focus on the modules that matter to your program.
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-10 p-5 rounded-2xl bg-slate-50 border border-slate-200">
                <div className="text-xs font-bold tracking-[0.2em] uppercase text-slate-500 mb-2">
                  Trouble with the calendar?
                </div>
                <a
                  href={TIDYCAL_URL}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="book-demo-fallback-link"
                  className="inline-flex items-center gap-1.5 text-[#22A34A] font-medium hover:gap-2.5 transition-all"
                >
                  Open TidyCal in a new tab
                  <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="rounded-3xl border border-slate-200 bg-white shadow-lg overflow-hidden" data-testid="tidycal-embed-container">
                {!loaded && (
                  <div className="h-[820px] flex flex-col items-center justify-center text-slate-500 gap-3">
                    <div className="w-10 h-10 border-2 border-[#22A34A]/30 border-t-[#22A34A] rounded-full animate-spin" />
                    <div className="text-sm">Loading calendar…</div>
                  </div>
                )}
                <iframe
                  src={TIDYCAL_URL}
                  title="Book a 60-minute demo with QC4Health"
                  width="100%"
                  height="820"
                  style={{ border: 0, display: loaded ? "block" : "none" }}
                  onLoad={() => setLoaded(true)}
                  data-testid="tidycal-iframe"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
